export default __webpack_public_path__ + "static/media/icue_465x.5eff851b.jpg";